import React, { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import { addPublicCustomClassNamePrefix } from '../utils/add-class-prefix'

interface QuestionItemProps {
  question: string
}

export const QuestionItem = ({
  question,
  children,
}: React.PropsWithChildren<QuestionItemProps>): ReactNode => {
  return (
    <li
      className={twMerge(
        `mt-3 rounded-md bg-THEME-block-background p-6 text-lg text-THEME-primary lg:mt-8`,
        addPublicCustomClassNamePrefix('course-quiz__question-item'),
      )}
    >
      <div
        className="no-p-y-margin wrap-break-word"
        dangerouslySetInnerHTML={{ __html: question }}
      />
      {children}
    </li>
  )
}
